export default "__VITE_ASSET__acf116f0__"